import React, { Component } from "react";
import PropTypes from "prop-types";

import Loading from "components/shared-components/Loading";
import {
  isChunkLoadError,
  reloadOnChunkLoadError,
} from "utils/chunkLoadRecovery";

class ChunkLoadErrorBoundary extends Component {
  state = {
    error: null,
  };

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error) {
    reloadOnChunkLoadError(error);
  }

  render() {
    const { children } = this.props;
    const { error } = this.state;

    if (!error) {
      return children;
    }

    if (isChunkLoadError(error)) {
      return <Loading cover="page" />;
    }

    throw error;
  }
}

ChunkLoadErrorBoundary.propTypes = {
  children: PropTypes.node.isRequired,
};

export default ChunkLoadErrorBoundary;
